package com.evoapps.evoshift.domain.usecase.auth

import com.evoapps.evoshift.domain.model.Device
import com.evoapps.evoshift.domain.model.DevicePlatform
import com.evoapps.evoshift.domain.repository.UserRepository
import com.evoapps.evoshift.domain.util.AppClock.now

class RegisterDeviceTokenUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(
        userId: String, 
        token: String, 
        platform: DevicePlatform,
        deviceName: String,
        oldToken: String? = null,
        /** The app's language, for the server's push text (SH-109). */
        language: String? = null
    ): Result<Unit> {
        return try {
            // 1. If we have an old token that is rotating, remove it first
            if (oldToken != null && oldToken != token) {
                userRepository.removeDeviceToken(userId, oldToken)
            }

            // 2. Save/Update current device info
            val device = Device(
                token = token,
                platform = platform,
                lastActiveAt = now().toString(),
                deviceName = deviceName,
                language = language
            )
            userRepository.saveDeviceToken(userId, device)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}